import TakerCard from '@/core/components/TakerCard/TakerCard';

export default TakerCard;
